import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiSetActiveEditItemId, uiSetActiveProjectId } from "Store/Actions";
import { selectSelectedOrActiveProjectIds } from "Store/Selectors/Projects";
import { selectActiveCompanyId, selectActiveContactId } from "Store/Selectors/UI";
import { hasElements } from "Utils/Array";
import { IAction } from "./IAction";

export function useEdit(): [boolean, IAction] {
  const dispatch = useDispatch();
  const selectedProjectIds = useSelector(selectSelectedOrActiveProjectIds);
  const [selectedProjectId] = hasElements(selectedProjectIds) ? selectedProjectIds : [null];
  const selectedCompanyId = useSelector(selectActiveCompanyId);
  const selectedContactId = useSelector(selectActiveContactId);
  const allowEdit = selectedProjectId != null && selectedProjectIds.length === 1;
  const activeEditItemId = selectedContactId ?? selectedCompanyId ?? selectedProjectId;

  const onEdit = useCallback(() => {
    if (!allowEdit) {
      return;
    }

    dispatch(uiSetActiveProjectId(selectedProjectId));
    dispatch(uiSetActiveEditItemId(activeEditItemId));
  }, [activeEditItemId, allowEdit, dispatch, selectedProjectId]);

  return [allowEdit, onEdit];
}
